import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ru } from './ru.js';
import { en } from './en.js';

/**
 * i18n: RU-первый интерфейс, EN сразу рядом (паспорт, раздел 00).
 * Язык: сохраненный выбор → язык системы → русский.
 */

const STORAGE_KEY = 'luum-locale';

function detectLocale(): 'ru' | 'en' {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ru' || saved === 'en') return saved;
  } catch {
    // ок, идем по navigator
  }
  return navigator.language.toLowerCase().startsWith('ru') ? 'ru' : 'en';
}

export function initI18n(): void {
  void i18next.use(initReactI18next).init({
    resources: { ru, en },
    lng: detectLocale(),
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
  });
}

export function setLocale(locale: 'ru' | 'en'): void {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // некритично
  }
  void i18next.changeLanguage(locale);
}
